import Message from "../../message";
import {useMainStore} from "@/store";

export default class ApplicationReceived extends Message
{
    handle()
    {
        useMainStore().ADD_GUILD_APPLICATION(this.message.application);
    }
}
